// material-ui
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

// ==============================|| LOGO ||============================== //

export default function LogoMain(_props?: { reverse?: boolean }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <img
        src="https://snugglescript.s3.us-east-1.amazonaws.com/public/logo.png"
        alt="SnuggleScript"
        width={32}
        height={32}
        style={{ borderRadius: 8 }}
      />
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#5F57FF', letterSpacing: '-0.3px' }}>
        SnuggleScript
      </Typography>
    </Stack>
  );
}
